import React, { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import Header from '../../components/Header'
import { arrayRemove, arrayUnion, doc, onSnapshot, updateDoc } from 'firebase/firestore'
import { auth, db } from '../../backend/firebase'
import User from '../../components/User'
import './DatasetAccess.css'

const DatasetAccess = () => {
  const [searchQuery, setSearchQuery] = useState('')
  const { datasetid } = useParams()
  const [userDetails, setUserDetails] = useState()
  const [accessedUsers, setAccessedUsers] = useState([])

  useEffect(() => {
    if (searchQuery.length === 28) {
      handleUserFetch(searchQuery)
    } else {
      setUserDetails(undefined)
    }
  }, [searchQuery])

  useEffect(() => {
    const fetchStatus = async() => {
        try {
            const accessDoc = doc(db, "datasets", datasetid)
            onSnapshot(accessDoc, (docSnap) => {
                if (docSnap.exists()) {
                  setAccessedUsers(docSnap.data().access_users || [])
                }
              })              
            console.log(doc.data().access_users)
        } catch(error){
            console.warn(error)
        }
    }
    fetchStatus()
  }, [])
  
  const handleUserFetch = async (id) => {
    const user = doc(db, "Users", id)
    onSnapshot(user, (data) => {
      if (data.exists()) {
        setUserDetails({
            id: data.id, 
            ...data.data()
        })
      } else {
        setUserDetails(undefined)
      }
    })
  }

  const grantAccess = async(id) => {
    try {
        const accessDoc = doc(db, "datasets", datasetid)
        await updateDoc(accessDoc, {
            access_users: arrayUnion(id)
        })
    } catch(error){
        console.warn(error)
    }
  }
  
  const removeAccess = async(id) => {
    try {
        const accessDoc = doc(db, "datasets", datasetid)
        await updateDoc(accessDoc, {
            access_users: arrayRemove(id)
        })
    } catch(error){
        console.warn(error)
    }
  }

  return (
    <div className="dataset-access-container">
      <div className="search-container">
        <input
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          className="search-input"
          placeholder='Add Users via SETA ID'
        />
      </div>
      <div className="content-container">
        {userDetails ? (
          <div className="user-details-card">
            <img 
              src={userDetails.profile_pic} 
              alt="PROFILE_PICTURE" 
              className="user-profile-image" 
            />
            <div className="user-info">
              <span className="user-name">{userDetails.displayName}</span>
              <span className="user-email">{userDetails.email}</span>
            </div>
            {accessedUsers?.includes(searchQuery) ? (
              <button 
                onClick={() => removeAccess(searchQuery)} 
                className="access-button revoke-button"
              >
                Revoke Access
              </button>
            ) : (
              <button 
                onClick={() => grantAccess(searchQuery)}
                className="access-button grant-button"
              >
                Grant Access
              </button>
            )}
          </div>
        ) : (
          <div className="users-list">
            {accessedUsers.map((id) => (
              <User 
                key={id} 
                userId={id} 
                func={() => removeAccess(id)} 
                title="Revoke Access" 
              />
            ))}
          </div>
        )}
      </div>
    </div>
  )
}

export default DatasetAccess